/**
 * @description 计算一段时间的毫秒数，如：一天1day = getTimeWithMillisecond(1, 'day'); 2小时2hour = getTimeWithMillisecond(2, 'hour');
 * @param n 数量
 * @param unit 时间单位，second-秒、minute-分钟，hour-小时、day-天、month-月、year-年
 * @returns millisecond 毫秒数
 */
const getTimeWithMillisecond = (n = 0, unit: string): number => {
  if (isNaN(Number(n)) || !unit) {
    throw new Error('getTimeWithMillisecond参数有误');
  }
  let coefficient = 1;
  switch (unit) {
    case 'second':
      coefficient = 1000;
      break;
    case 'minute':
      coefficient = 1000 * 60;
      break;
    case 'hour':
      coefficient = 1000 * 60 * 60;
      break;
    case 'day':
      coefficient = 1000 * 60 * 60 * 24;
      break;
    case 'month':
      coefficient = 1000 * 60 * 60 * 24 * 30;
      break;
    case 'year':
      coefficient = 1000 * 60 * 60 * 24 * 30 * 12;
      break;
    default:
      break;
  }
  return new Date().getTime() + n * coefficient;
};

export default getTimeWithMillisecond;
